import { Monitor } from 'lucide-react';

/**
 * Desktop-only handoff into the native ShotSelect app. The same share link a
 * client opens in the browser can be reviewed in an installed desktop app via
 * the registered `shotselect://review/<token>` protocol — the main process
 * parses the token and opens a guest cull session, and picks fold back through
 * the same public share API. Hidden on phones (≤ md) because the desktop app
 * can't run there; phone clients stay in the web gallery. Mirrors the
 * worker-rendered gallery twin's "Open in ShotSelect app" affordance so both
 * browser surfaces behave the same.
 *
 * The voter token is intentionally omitted — the app fetches the manifest
 * fresh from the share token and mints its own voter identity, so the link is
 * the minimal `shotselect://review/<token>`.
 */
export function OpenInAppLink({ shareToken }: { shareToken: string | null }) {
  if (!shareToken) return null;
  const href = `shotselect://review/${encodeURIComponent(shareToken)}`;
  return (
    <a
      href={href}
      data-testid="open-native-review"
      className="hidden h-10 shrink-0 items-center gap-1.5 rounded-full border border-white/15 px-4 text-[11px] font-semibold uppercase tracking-[0.14em] text-white/70 backdrop-blur-md transition hover:border-white/30 hover:text-white md:inline-flex"
    >
      <Monitor size={13} strokeWidth={2} aria-hidden />
      Open in app
    </a>
  );
}
